var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tagIcon",style:('background-color:' + _vm.itemData.color),on:{"mouseenter":_vm.iconHover,"mouseleave":_vm.iconHoverLeave}},[_vm._v(" "+_vm._s(_vm.itemData.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }